export default __webpack_public_path__ + "static/media/image4.8b3d1ba7.png";